<template>
  <div>
    <table v-if="loaded"
           class="asd-table"
    >
      <thead>
        <tr class="table-heading">
          <th>uživatel</th>
          <th>datum</th>
          <th>vlastnost</th>
          <th>verze dat</th>
          <th>operace</th>
          <th>ze stavu</th>
          <th>do stavu</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in history"
            :key="row.id"
        >
          <td>{{ row.creatorUsername }}</td>
          <td>{{ row.createdAt | formatTimestamp }}</td>
          <td>{{ row.propertyName }}</td>
          <td>{{ row.version }}</td>
          <td :class="[`op-${row.eventType}`]">
            {{ row.operation }}
          </td>
          <td>
            <PropertyDetailProxy :id="row.key"
                                 :key="row.key"
                                 :value="row.fromValue"
            ></PropertyDetailProxy>
          </td>
          <td>
            <PropertyDetailProxy :id="row.key"
                                 :key="row.key"
                                 :value="row.toValue"
            ></PropertyDetailProxy>
          </td>
        </tr>
      </tbody>
    </table>
    <Spinner v-else></Spinner>
  </div>
</template>

<script>
import { map, get, sortBy } from 'lodash'
import { defaultApiMiddleware as api } from 'CORE/stores'
import Spinner from 'CORE/components/utilities/spinner'
import EventBus from 'CORE/bus'
import PropertyDetailProxy from 'CORE/components/data-type/property-detail-proxy'

const OPERATIONS = {
    created: 'vytvořeno',
    updated: 'upraveno',
    deleted: 'smazáno',
}

export default {
    name: 'PropertyHistory',
    components: {
        Spinner,
        PropertyDetailProxy,
    },
    props: {
        entity: {
            type: String,
            required: true,
            default: () => null,
        },
    },
    data() {
        return {
            history: [],
            loaded: false,
        }
    },
    async mounted() {
        try {
            this.history = await api.get(`/propertyHistory?where[entity]=${this.entity}`)
            this.history = map(this.history, row => {
                row.creatorUsername = get(this.$store.getters.userById(row.creator.id), 'username')
                row.propertyName = get(this.$store.getters.propertyTypeByKey(row.key), 'name')
                row.operation = get(OPERATIONS, row.eventType, 'neznámá')
                row.fromValue = { value: row.fromValue }
                row.toValue = { value: row.toValue }
                return row
            })
            this.history = sortBy(this.history, row => -row.createdAt)
        } catch (e) {
            EventBus.$emit('FLASH_USER_ERROR', { message: e })
        } finally {
            this.loaded = true
        }
    },
}
</script>

<style lang="scss" scoped>
.op-created {
    color: green;
}
.op-updated {
    color: black;
}
.op-deleted {
    color: red;
}
</style>
